import { GamStoreId } from '@/views/composables/constants/main/store.constants';
import { defineStore } from 'pinia';
import { ref } from 'vue';
import { useRouter } from 'vue-router';

export const useAppStore = defineStore(GamStoreId.APP, () => {
  const router = useRouter();

  const previousPath = ref<string>();
  const dialogOpen = ref<boolean>(false);
  const drawerOpen = ref<boolean>(false);
  const imageExpanded = ref<boolean>(false);
  const imageUploading = ref<boolean>(false);
  const isAutomation = ref<boolean>(!!window.isAutomation);

  const isOnline = ref<boolean>(navigator.onLine);
  const wasOffline = ref<boolean>(!navigator.onLine);

  const setDialogOpen = (value: boolean) => {
    dialogOpen.value = value;
  };

  const setDrawerOpen = (value: boolean) => {
    drawerOpen.value = value;
  };

  const setImageExpanded = (value: boolean) => {
    imageExpanded.value = value;
  };

  const setImageUploading = (value: boolean) => {
    imageUploading.value = value;
  };

  window.addEventListener('online', () => {
    isOnline.value = true;
  });
  window.addEventListener('offline', () => {
    isOnline.value = false;
    wasOffline.value = true;
  });

  router.afterEach((to, from) => {
    previousPath.value = from.fullPath;
  });

  const isFirstVisit = () => {
    return previousPath.value === '/';
  };

  return {
    previousPath,
    dialogOpen,
    drawerOpen,
    imageExpanded,
    imageUploading,
    setDialogOpen,
    setDrawerOpen,
    setImageExpanded,
    setImageUploading,
    isFirstVisit,
    isAutomation,
    isOnline,
    wasOffline,
  };
});
